import React, {Component} from "react"

import Button from "@irati/ui/src/Button"
import AddOnePerson from "@irati-web/admin/src/containers/Users/AddOnePerson/AddOnePerson"
import AddMultiplePeople from "@irati-web/admin/src/containers/Users/AddMultiplePeople/AddMultiplePeople"
import {Team} from "@irati/types"
import {Para} from "@irati/ui/src/Labels"
import {H3} from "@irati/ui/src//Typography/Heading"
import {FormattedMessage} from "@irati/utils/lang"
import Icon from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"

import {Card, RelativeContainer, IconWrapper} from "../styled"

enum InviteFlow {
  Manual = "Manual",
  Csv = "Csv"
}

interface Props {
  onCallback: () => void,
  teams: Team[]
}

interface State {
  inviting?: InviteFlow
}

class InvitePeople extends Component<Props, State> {
  state: State = {}

  handleStartInvite = (flow: InviteFlow) => {
    this.setState({inviting: flow})
  }

  render() {
    const {inviting} = this.state
    const {onCallback, teams} = this.props
    if (inviting === InviteFlow.Manual) {
      return <AddOnePerson gotoSuccess={onCallback} goBack={onCallback} teams={teams} />
    }
    if (inviting === InviteFlow.Csv) {
      return <AddMultiplePeople goBack={onCallback} gotoSuccess={onCallback} teams={teams} />
    }
    return (
      <RelativeContainer>
        <Flex alignItems="center">
          <IconWrapper onClick={this.props.onCallback}>
            <Icon icon="backArrow" size={25} />
          </IconWrapper>
          <H3>
            <FormattedMessage id="setup_tenant.steps.invite.addPeopleOptions.title" />
          </H3>
        </Flex>
        <Para margin="30px 0">
          <FormattedMessage id="setup_tenant.steps.invite.addPeopleOptions.description" />
        </Para>
        <Flex justifyContent="space-between">
          <Card>
            <Para center margin="0 0 30px">
              <FormattedMessage id="setup_tenant.steps.invite.addPeopleOptions.addManual.description" />
            </Para>
            <Button primary onClick={() => this.handleStartInvite(InviteFlow.Manual)}>
              <FormattedMessage id="setup_tenant.steps.invite.addPeopleOptions.addManual.cta" />
            </Button>
          </Card>
          <Card>
            <Para center margin="0 0 30px">
              <FormattedMessage id="setup_tenant.steps.invite.addPeopleOptions.addCsv.description" />
            </Para>
            <Button primary onClick={() => this.handleStartInvite(InviteFlow.Csv)}>
              <FormattedMessage id="setup_tenant.steps.invite.addPeopleOptions.addCsv.cta" />
            </Button>
          </Card>
        </Flex>
      </RelativeContainer>
    )
  }
}

export default InvitePeople
